// @flow
import React, { Component } from 'react'
import { translations, translateFunc } from '../../shared/localize'
import _ from 'lodash'
import styled, { type StyledComponent } from 'styled-components'
import postJson from '../../services/postJson'
import Select from '../controls/Select'
import ErrorText from '../controls/ErrorText'
import type { OptionType } from '../types'

const Lookalike: StyledComponent<Object, any, any> = styled.div`
  width: 460px;
`
const InputGroup: StyledComponent<Object, any, any> = styled.div`
  font-size: 14px;
  padding-bottom: 12px;
`

const NameField: any = (((styled.input: any).attrs({
  type: 'text',
  className: 'form-control input-item lookalike-form__input-item'
}): any)`
  width: 100%;
`: any)

type Errors = Array<string>

type Props = {|
  onClose: Function,
  origins: Array<Object>,
  countries: Array<OptionType>,
  defaultCountryId: number,
  onObjectCreated: Function
|}

type State = {|
  name: string,
  level: number,
  origin: Object,
  countryId: number,
  isLoading: boolean,
  nameErrors: Errors,
  levelErrors: Errors,
  originIdErrors: Errors,
  originTypeErrors: Errors,
  locationIdErrors: Errors,
  changedName: boolean
|}

type ErrorResponse = {|
  name?: Errors,
  level?: Errors,
  origin_id?: Errors,
  origin_type?: Errors,
  location_id?: Errors
|}

const t = translateFunc(translations.lookalike_form)

const levels = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]

const createLookalikeUrl = '/api/v1/lookalikes/'

export default class LookalikeForm extends Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = {
      name: '',
      level: 0,
      countryId: props.defaultCountryId,
      origin: {},
      isLoading: false,
      nameErrors: [],
      levelErrors: [],
      originIdErrors: [],
      originTypeErrors: [],
      locationIdErrors: [],
      changedName: false
    }
  }

  levelOptions(): Array<[string, number]> {
    return _.map(levels, (level: number) => {
      return [t(level, { _: String(level) }), level]
    })
  }

  originOptions(): Array<[string, number]> {
    const { origins } = this.props
    return _.map(origins, (origin: Object, index: number) => {
      return [origin.name, index]
    })
  }

  buildLookalikeName() {
    const { level, origin } = this.state
    if (level === 0) {
      return `LAL ${origin.name}`
    } else if (_.isEmpty(origin) || origin.name === t('empty_origin')) {
      return `LAL[${level}]`
    } else {
      return `LAL[${level}] ${origin.name}`
    }
  }

  resetForm() {
    const { defaultCountryId } = this.props
    this.setState({ name: '', level: 0, origin: {}, countryId: defaultCountryId })
  }

  handleSubmit() {
    const { name, level, origin, countryId } = this.state
    const { onClose, onObjectCreated } = this.props
    this.setState({ isLoading: true })
    postJson(createLookalikeUrl, {
      data: {
        name: name,
        level: level,
        origin_id: origin.id,
        origin_type: origin.type,
        location_id: countryId
      }
    })
      .done(({ data: lookalike }: Object) => {
        onClose()
        this.resetForm()
        onObjectCreated(lookalike)
      })
      .fail(({ responseJSON }: any) => {
        const responseObject: ErrorResponse = responseJSON.message
        this.setState({
          nameErrors: responseObject.name || [],
          levelErrors: responseObject.level || [],
          originIdErrors: responseObject.origin_id || [],
          originTypeErrors: responseObject.origin_type || [],
          locationIdErrors: responseObject.location_id || []
        })
      })
      .always(() => this.setState({ isLoading: false }))
  }

  onLevelChange(levelValue: number) {
    const { changedName } = this.state
    this.setState({ level: levelValue }, () => {
      if (!changedName) {
        this.setState({ name: this.buildLookalikeName() })
      }
    })
  }

  onOriginChange(originIndex: number) {
    const { origins } = this.props
    const { changedName } = this.state
    this.setState({ origin: origins[originIndex] }, () => {
      if (!changedName) {
        this.setState({ name: this.buildLookalikeName() })
      }
    })
  }

  onNameChange(e: Object) {
    this.setState({ changedName: true })
    this.setState({ name: e.target.value })
  }

  render() {
    const {
      name,
      isLoading,
      nameErrors,
      levelErrors,
      originIdErrors,
      originTypeErrors,
      locationIdErrors,
      origin,
      level,
      countryId
    } = this.state
    const { origins, countries } = this.props
    return (
      <Lookalike>
        <h2>{t('create_lookalike')}</h2>
        <InputGroup className="t-LookalikeForm__LevelSelectWrapper">
          <Select
            value={level}
            placeholder={t('empty_level')}
            options={Select.optionsFromTuples(this.levelOptions())}
            disabled={isLoading}
            onChange={(levelValue) => this.onLevelChange(levelValue)}
          />
          <ErrorText errors={levelErrors} />
        </InputGroup>
        <InputGroup className="t-LookalikeForm__OriginSelectWrapper">
          <Select
            value={origins.indexOf(origin)}
            placeholder={t('empty_origin')}
            options={Select.optionsFromTuples(this.originOptions())}
            disabled={isLoading}
            onChange={(originIndex) => this.onOriginChange(originIndex)}
          />
          <ErrorText errors={[...originIdErrors, ...originTypeErrors]} />
        </InputGroup>
        <InputGroup>
          <NameField
            disabled={isLoading}
            name="lookalike_name"
            placeholder={t('name_placeholder')}
            value={name}
            onChange={(e) => this.onNameChange(e)}
          />
          <ErrorText errors={nameErrors} />
        </InputGroup>
        <InputGroup className="t-LookalikeForm__CountrySelectWrapper">
          <Select
            value={countryId}
            placeholder={t('empty_country')}
            options={countries}
            disabled={isLoading}
            onChange={(countryId) => this.setState({ countryId: countryId })}
          />
          <ErrorText errors={locationIdErrors} />
        </InputGroup>
        <input
          type="submit"
          name="commit"
          disabled={isLoading}
          onClick={() => this.handleSubmit()}
          className="blue-button"
          value={t('create_lookalike')}
        />
      </Lookalike>
    )
  }
}
